const OptimizedImage = ({
  src,
  alt,
  className = "",
  width,
  height,
  sizes = "(max-width: 768px) 100vw, 50vw",
  loading = "lazy",
  ...props
}) => {
  // Get the base name without extension
  const baseName = src.replace(/\.[^/.]+$/, "").replace(/^\//, "");

  // Create WebP sources with different sizes
  const webpSrc = `/${baseName}.webp`;
  const webp2x = `/${baseName}@2x.webp`;

  return (
    <picture>
      {/* WebP sources with responsive sizing */}
      <source
        srcSet={`${webpSrc} 1x, ${webp2x} 2x`}
        type="image/webp"
        sizes={sizes}
      />
      {/* Fallback to original image */}
      <img
        src={src}
        alt={alt}
        className={className}
        width={width}
        height={height}
        loading={loading}
        {...props}
      />
    </picture>
  );
};

export default OptimizedImage;
